import { Pipe, PipeTransform } from '@angular/core';


@Pipe({
  name: 'tutoriales',
})
export class TutorialesPipe implements PipeTransform {

  transform(items: any[], filter: any[]) {

    if(filter && items) {

      console.log(filter['tipo']);
      console.log(items);
      if (filter['tipo']) {

        items = items.filter(function (item) {
          return item.tipo == filter['tipo'];
        });
      }
    }

    return items;

  }
}



// WEBPACK FOOTER //
// ./src/pipes/tutoriales/tutoriales.ts